import { Component, inject, viewChild, ChangeDetectionStrategy } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { NewDialogComponent } from "common/newdialog/dialog.component";
import { Observable } from "rxjs";
import { switchMap } from "rxjs/operators";
import { DialogHeaderComponent } from "common/newdialog/dialog-header.component";
import { AsyncPipe } from "@angular/common";

@Component({
	selector: "stages-files-oauth-confirm",
	templateUrl: "./files-oauth-confirm.component.html",
	styleUrls: ["./files-oauth-confirm.component.scss"],
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [NewDialogComponent, DialogHeaderComponent, TranslateModule, AsyncPipe],
})
export class FilesOAuthConfirmComponent {
	private route = inject(ActivatedRoute);
	private translateService = inject(TranslateService);

	readonly dialog = viewChild.required<NewDialogComponent>("dialog");

	cmType$: Observable<string>;
	authUrl: string | null;

	constructor() {
		this.cmType$ = this.route.paramMap.pipe(
			switchMap((paramMap) => this.translateService.get(paramMap.get("cmTypeMessageKey")!)),
		);
		this.authUrl = this.route.snapshot.paramMap.get("authUrl");
	}

	submit(): void {
		if (this.authUrl) {
			window.location.href = this.authUrl;
		}
	}

	close(): void {
		this.dialog().close();
	}
}
